import { IconHelpSquareRounded } from '@calendly/ui/components/glyphs/IconHelpSquareRounded';
import { SwitchInput } from '@calendly/ui/components/switch-input';
import { Tooltip } from '@calendly/ui/components/tooltip';
import { UiIcon } from '@calendly/ui/components/ui-icon';
import { useProductRefreshPreviewToggle } from './useProductRefreshPreviewToggle';
const rootCss = "r2immtt";
const rootWithBorderCss = "r1vnahk4";
const helpIconCss = "hel1h7d";
const HELP_TOOLTIP_TEXT = 'Product Refresh Preview. Experience the new app shell and Brand 2026 theme, currently under active development.';
interface ProductRefreshPreviewToggleProps {
  showBorder?: boolean;
}

/**
 * Dev-only: toggle to preview the new app shell and Brand 2026 theme.
 * Appears in the legacy header and new app bar. Turning it on is required (with feature flags) for the new shell and theme.
 * See `useProductRefreshAppShell` / `useProductRefreshUiTheme`.
 */
export function ProductRefreshPreviewToggle({
  showBorder = false
}: ProductRefreshPreviewToggleProps = {}) {
  const {
    checked,
    onChange
  } = useProductRefreshPreviewToggle();
  return <div className={`${rootCss} ${showBorder ? rootWithBorderCss : ''}`} data-testid="app-layout-debug-switch">
      <label>
        <SwitchInput aria-label="Product refresh layout and Brand 2026 theme" checked={checked} onChange={onChange} />
      </label>
      <Tooltip text={HELP_TOOLTIP_TEXT} zIndex={350}>
        <span className={helpIconCss}>
          <UiIcon icon={IconHelpSquareRounded} size="small" />
        </span>
      </Tooltip>
    </div>;
}

require("./ProductRefreshPreviewToggle.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./ProductRefreshPreviewToggle.tsx");